(function() {
  'use strict';

  var header = document.querySelector('.site-header');
  var lastScroll = 0;
  if (header && !window.matchMedia('(max-width: 768px)').matches) {
    window.addEventListener('scroll', function() {
      var curr = window.scrollY;
      if (curr > 120 && curr > lastScroll) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
      if (curr > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = curr;
    }, { passive: true });
  }

  var cards = document.querySelectorAll('.coll-card-image, .product-card');
  if (cards.length > 0 && !window.matchMedia('(max-width: 768px), (prefers-reduced-motion: reduce)').matches) {
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var cx = rect.width / 2;
        var cy = rect.height / 2;
        card.style.transform = 'perspective(600px) rotateX(' + (((y - cy) / cy) * -4) + 'deg) rotateY(' + (((x - cx) / cx) * 4) + 'deg) scale3d(1.02,1.02,1.02)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(600px) rotateX(0) rotateY(0) scale3d(1,1,1)';
        card.style.transition = 'transform 0.4s ease';
      });
    });
  }
})();
